import Uploader, { UploaderProps } from './Uploader';
import { UploaderFile, UploaderFilesListProps } from './types';

export default Uploader;
export type { UploaderProps, UploaderFile, UploaderFilesListProps };
